import { inject } from '@angular/core';
import * as fromScreen from '@app/root-store/ui/screen';
import { Store } from '@ngrx/store';

export const onlyDesktopDeactivate = () => {
  const store = inject(Store);
  store.dispatch(fromScreen.setDesktopOnlyViewActive({desktopOnly: false}))
  return true;
}